import get from 'lodash/get';

import lowerCase from 'lodash/lowerCase';
import localStorage from "utils/localStorage";
import { PROFILE_KEY, QUESTIONS_KEY, LOCALE_KEY, STAGE_TYPE_KEY, PREVIOUS_STAGE_KEY, FLASH_MESSAGE_KEY } from "utils/app-constants";

import {  AuthSubject } from "shared/AuthSubject";

class Auth{
  isAuthenticated(){
    return this.getUser() ? true : false;
  }

  getUser(){
    return get(localStorage.getList(PROFILE_KEY), 'user');
  }

  getToken() {
    return get(localStorage.getList(PROFILE_KEY), "access_token", '');
  }

  getQuestions() {
    try {
      return localStorage.getList(QUESTIONS_KEY);
    } catch (error) {
      localStorage.removeItem(PROFILE_KEY);
      AuthSubject.next({ profile: '' });
      return [];
    }
  }

  setLanguage (lang) {
    localStorage.saveList(LOCALE_KEY, lang);
  }

  getLanguage() {
    try {
      return localStorage.getList(LOCALE_KEY);
    } catch (error) {
      return {
        local_locale: 'en',
        lang: 'en_US'
      }
    }
  }

  isSurveyMode() {
    return lowerCase(localStorage.getItem(STAGE_TYPE_KEY)) === 'survey' ? true : false;
  }

  saveFlashMessage(message) {
    localStorage.saveItem(FLASH_MESSAGE_KEY, message);
  }

  getFlashMessage() {
    return localStorage.getItem(FLASH_MESSAGE_KEY) || '';
  }

  logout(){
    localStorage.removeItem(get(this.getUser(), 'current_stage_id'));
    localStorage.removeItem(localStorage.getItem(PREVIOUS_STAGE_KEY));
    localStorage.removeItem(QUESTIONS_KEY);
    localStorage.removeItem(STAGE_TYPE_KEY);
    localStorage.removeItem(PREVIOUS_STAGE_KEY);
    localStorage.removeItem(PROFILE_KEY);

    AuthSubject.next({ profile: false, locale: this.getLanguage()});
  }
}

export default new Auth();


// WEBPACK FOOTER //
// ./src/shared/Auth.js